import { AxiosResponse } from 'axios';
import { USDA_KEY } from '../../utils/constants';

import request from '../request';
// https://fdc.nal.usda.gov/api-spec/fdc_api.html

export default {
  searchProduct: async (values: SearchFoodQuery): Promise<AxiosResponse<SearchResult>> => {
    return request(
      `https://api.nal.usda.gov/fdc/v1/foods/search?query=${values.query}&sortBy=dataType.keyword&brandOwner=${values.brandOwner}&dataType=Branded&api_key=${USDA_KEY}`,
      'get',
    );
  },
  searchFood: async (values: SearchFoodQuery): Promise<AxiosResponse<SearchResult>> => {
    return request(
      `https://api.nal.usda.gov/fdc/v1/foods/search?query=${values.query}&sortBy=dataType.keyword&dataType=Foundation, Survey (FNDDS), SR Legacy&api_key=${USDA_KEY}`,
      'get',
    );
  },
  getProductInfoById: async (fdcId) => {
    return request(`https://api.nal.usda.gov/fdc/v1/food/${fdcId}?api_key=${USDA_KEY}`, 'get');
  },
};
